import { Box, LinearProgress } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { motion } from "framer-motion";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useLocation } from "react-router-dom";
import FiltrosRedux from "../../contexts/Filtros";
import MultiplosFiltrosRedux from "../../contexts/MultiplosFiltros.js";
import { useProfile } from "../../contexts/ProfileContext.tsx";
import Icon from "../../core/components/Icon.tsx";
import IconButton from "../../core/components/IconButton.tsx";
import Separator from "../../core/components/Separator.tsx";
import {
	formatarDataISO,
	hojeFormatado,
	primeiroDiaDosMesFormatado,
	ultimoDiaDosMesFormatado,
} from "../../core/utils/UtilityDates.ts";
import iconeAnterior from "../../images/iconeAnterior.png";
import iconeProximo from "../../images/iconeProximo.png";
import ModalMultiplosFiltros from "../ModalMultiplosFiltros/ModalMultiplosFiltros.tsx";
import "./FiltroV2.css";

const opcoesTipo = [
	{
		opcao: "Ambos",
		valor: 1,
	},
	{
		opcao: "Carregando",
		valor: 2,
	},
	{
		opcao: "Descarregando",
		valor: 3,
	},
];

const opcoesBrf = [
	{
		opcao: "Todos",
		valor: 5,
	},
	{
		opcao: "Elegível Padrão BRF",
		valor: 1,
	},
	{
		opcao: "Elegível BRF Spot",
		valor: 2,
	},
	{
		opcao: "Inelegível Padrão BRF",
		valor: 3,
	},
	{
		opcao: "Elegível BRF OTM",
		valor: 4,
	},
];

const formatarData = (dataString) => {
	const data = new Date(dataString);
	const dia = data.getDate().toString().padStart(2, "0");
	const mes = (data.getMonth() + 1).toString().padStart(2, "0");
	const ano = data.getFullYear();
	return `${ano}-${mes}-${dia}`;
};

function FiltroV2({
	classe,
	itensFiltro,
	valuesPesquisa,
	setValuesPesquisa,
	buscarSearch,
	limpar,
	setCompleto,
	setPeriodoCompleto,
	periodoCompleto,
	classOption,
	listaGrupos,
	mesAnterior,
	mesSeguinte,
	setEstadia,
	setFiltroEstadia,
	estadia,
}) {
	const { contextoEmbarque, dadosFilial, handleSetContextoEmbarque } =
		useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const location = useLocation();
	const prevPathname = useRef(location.pathname);

	const isRotaViagens = useMemo(() => {
		return location.pathname.includes("/viagens");
	}, [location.pathname]);

	const isRotaMotorista = useMemo(() => {
		return location.pathname.includes("/motorista");
	}, [location.pathname]);

	const isRotaLocalizadorVeiculos = useMemo(() => {
		return location.pathname.includes("localizador-veiculos");
	}, [window.location.href]);

	const isRotaMapaMeso = useMemo(() => {
		return location.pathname.includes("mapa-meso");
	}, [window.location.href]);

	const isRotaFaturamento = useMemo(
		() => location.pathname.endsWith("faturamento"),
		[location.pathname]
	);

	const isRotaDashboardCotacao = useMemo(() => {
		return location.pathname.includes("dashboard-cotacao");
	}, [window.location.href]);

	const isRotaDashboard = useMemo(
		() => location.pathname.endsWith("dashboard")[location.pathname]
	);

	const isRotaDashboardSegundo = useMemo(() => {
		return location.pathname.endsWith("dashboard-terceiro");
	}, [location.pathname]);

	const isRotaDashboardTerceiro = useMemo(() => {
		return location.pathname.endsWith("dashboard-quarto");
	}, [location.pathname]);

	const isRotaMesorregiao = useMemo(() => {
		return location.pathname.endsWith("mesorregiao");
	}, [location.pathname]);

	const isRotaViagensId = useMemo(
		() =>
			location.search.includes("id=") &&
			contextoEmbarque !== "templateEmbarque",
		[location.search, contextoEmbarque]
	);

	const [openFiltrar, setOpenFiltrar] = useState(false);
	const [openFiltrar2, setOpenFiltrar2] = useState(false);
	const [valorSelecionado, setValorSelecionado] = useState(valuesPesquisa.item);
	const [opcaoSelecionada, setOpcaoSelecionada] = useState(null);
	const [filtroSelecionado, setFiltroSelecionado] = useState(null);

	const onClickFiltrar2 = () => {
		setOpenFiltrar2(!openFiltrar2);
		setOpenCidade(false);
	};

	const onClickFiltrar = () => {
		setOpenFiltrar(!openFiltrar);
		setOpenCidade(false);
	};

	const onClickOpcaoFiltrar = (value, option, nome) => {
		setValorSelecionado(value);
		setOpcaoSelecionada(option);
		setFiltroSelecionado(nome);
		setValuesPesquisa((current) => ({ ...current, item: value }));
		setFiltrosRedux((current) => ({ ...current, filtroNome: nome }));
		setFiltrosRedux((current) => ({ ...current, item: value }));
		setOpenFiltrar(false);
	};

	const [openCidade, setOpenCidade] = useState(false);
	const [valorSelecionadoCidade, setValorSelecionadoCidade] = useState(
		valuesPesquisa.item
	);
	const [opcaoSelecionadaCidade, setOpcaoSelecionadaCidade] = useState(null);
	const [cidadeFiltro, setCidadeFiltro] = useState(null);

	const onClickCidade = () => {
		setOpenCidade(!openCidade);
		setOpenFiltrar(false);
	};

	const onClickOpcaoCidade = (value, option, cidade, boolean) => {
		setValorSelecionadoCidade(value);
		setOpcaoSelecionadaCidade(option);
		setCidadeFiltro(cidade);
		setValuesPesquisa((current) => ({ ...current, contexto: value }));
		handleSetContextoEmbarque(value);
		setFiltrosRedux((current) => ({ ...current, filial: cidade }));
		setFiltrosRedux((current) => ({ ...current, contexto: value }));
		setOpenCidade(false);
	};

	const [openTipo, setOpenTipo] = useState(false);
	const [valorSelecionadoTipo, setValorSelecionadoTipo] = useState(
		valuesPesquisa.item
	);
	const [opcaoSelecionadaTipo, setOpcaoSelecionadaTipo] = useState(null);
	const [tipoFiltro, setTipoFiltro] = useState(null);

	const onClickTipo = () => {
		setOpenTipo(!openTipo);
		setOpenFiltrar(false);
	};

	const onClickOpcaoTipo = (value, option, tipo, boolean) => {
		setValorSelecionadoTipo(value);
		setOpcaoSelecionadaTipo(option);
		setTipoFiltro(tipo);
		setValuesPesquisa((current) => ({ ...current, tipo: value }));
		setFiltrosRedux((current) => ({ ...current, tipo: tipo }));
		setFiltrosRedux((current) => ({ ...current, tipo: value }));
		setOpenTipo(false);
	};

	const [openElegivelBrf, setOpenElegivelBrf] = useState(false);
	const [valorSelecionadoElegivelBrf, setValorSelecionadoElegivelBrf] =
		useState(valuesPesquisa.item);
	const [opcaoSelecionadaElegivelBrf, setOpcaoSelecionadaElegivelBrf] =
		useState(null);
	const [elegivelBrfFiltro, setElegivelBrfFiltro] = useState(null);

	const onClickElegivelBrf = () => {
		setOpenElegivelBrf(!openElegivelBrf);
		setOpenFiltrar(false);
	};

	const onClickOpcaoElegivelBrf = (value, option, tipo, boolean) => {
		setValorSelecionadoElegivelBrf(value);
		setOpcaoSelecionadaElegivelBrf(option);
		setElegivelBrfFiltro(tipo);
		setValuesPesquisa((current) => ({ ...current, elegivelBrf: value }));
		setFiltrosRedux((current) => ({ ...current, elegivelBrfTipo: tipo }));
		setFiltrosRedux((current) => ({ ...current, elegivelBrf: value }));
		setOpenElegivelBrf(false);
	};

	const [openGrupoCliente, setOpenGrupoCliente] = useState(false);
	const [valorSelecionadoGrupoCliente, setValorSelecionadoGrupoCliente] =
		useState(valuesPesquisa.item);
	const [opcaoSelecionadaGrupoCliente, setOpcaoSelecionadaGrupoCliente] =
		useState(null);
	const [grupoClienteFiltro, setGrupoClienteFiltro] = useState(null);

	const onClickGrupoCliente = () => {
		setOpenGrupoCliente(!openGrupoCliente);
		setOpenFiltrar(false);
	};

	const onClickOpcaoGrupoCliente = (value, option, cidade, boolean) => {
		setValorSelecionadoGrupoCliente(value);
		setOpcaoSelecionadaGrupoCliente(option);
		setGrupoClienteFiltro(cidade);
		setValuesPesquisa((current) => ({ ...current, grupoCliente: value }));
		setFiltrosRedux((current) => ({ ...current, grupoClienteNome: cidade }));
		setFiltrosRedux((current) => ({ ...current, grupoCliente: value }));
		setOpenGrupoCliente(false);
	};

	const [openOpcionais, setOpenOpcionais] = useState(false);

	const onClickOpcionais = () => {
		setOpenOpcionais(!openOpcionais);
	};

	const { filtrosRedux, setFiltrosRedux } = useContext(FiltrosRedux);

	const converterData = (data) => {
		if (typeof data !== "string" || !data.includes("-")) {
			console.error("Formato inválido ou data não fornecida.");
			return null;
		}

		const parts = data.split("-");
		if (parts.length !== 3) {
			console.error("Data incompleta ou formato incorreto.");
			return null;
		}

		return `${parts[2]}-${parts[1]}-${parts[0]}`;
	};

	const [valuesSelect, setValuesSelect] = useState({
		embarqueInicio: "",
		embarqueFinal: "",
		embarqueInicioDisp: "",
		embarqueFinalDisp: "",
	});

	const [inputDisable, setInputDisable] = useState(true);

	const [loadingInput, setLoadingInput] = useState(false);

	const [openMultiplosFiltros, setOpenMultiplosFiltros] = useState(false);

	const handleCloseMultiplosFiltros = (value) => {
		setOpenMultiplosFiltros(false);
	};

	useEffect(() => {
		setLoadingInput(true);
		if (
			valuesPesquisa.item === "previsaoEmbarque" ||
			valuesPesquisa.item === "dataEmbarque" ||
			valuesPesquisa.item === "dataEntrega" ||
			valuesPesquisa.item === "previsaoEntrega"
		) {
			var date = new Date();
			var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			setValuesPesquisa((current) => ({ ...current, pesquisa: primeiroDia }));
			setInputDisable(false);
			setLoadingInput(false);
		} else {
			setValuesPesquisa((current) => ({ ...current, pesquisa: "" }));
			setLoadingInput(false);
		}
	}, [valuesPesquisa.item]);

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			embarqueInicio: "01-01-2020",
			embarqueFinal: "01-01-2050",
			tipo: 3,
			contexto: "todos",
			elegivelBrf: 5,
		}));
		onClickOpcaoTipo(3, 3, "Descarregando", "false");
		onClickOpcaoCidade("todos", "todos", "Todos", "false");
		onClickOpcaoElegivelBrf(5, 5, "Todos", "false");
		if (contextoEmbarque) {
			const filialSelecionada = dadosFilial
				.filter((filial) => filial.contexto !== "templateEmbarque")
				.find((filial) => filial.contexto === contextoEmbarque);
			const contexto =
				contextoEmbarque === "templateEmbarque" ? "todos" : contextoEmbarque;
			onClickOpcaoCidade(
				contexto,
				contexto,
				filialSelecionada ? filialSelecionada.nomeFilial : "Todos",
				"false"
			);
		}
		if (filtrosRedux.elegivelBrf && filtrosRedux.elegivelBrfTipo) {
			onClickOpcaoElegivelBrf(
				filtrosRedux.elegivelBrf,
				filtrosRedux.elegivelBrf,
				filtrosRedux.elegivelBrfTipo,
				"false"
			);
		}
		if (window.location.href.endsWith("dashboard-cockpit")) {
			onClickOpcaoGrupoCliente(1, 1, listaGrupos[0]?.nome, "false");
			if (filtrosRedux.grupoCliente) {
				onClickOpcaoGrupoCliente(
					filtrosRedux.grupoCliente,
					filtrosRedux.grupoCliente,
					filtrosRedux.grupoClienteNome,
					"false"
				);
			}
		}
		if (filtrosRedux.item && filtrosRedux.filtroNome) {
			onClickOpcaoFiltrar(
				filtrosRedux.item,
				filtrosRedux.item,
				filtrosRedux.filtroNome
			);
		}
		if (
			filtrosRedux.embarqueFinal !== "01-01-2050" &&
			filtrosRedux.embarqueFinal
		) {
			setValuesSelect((current) => ({
				...current,
				embarqueFinal: filtrosRedux.embarqueFinal,
			}));
		}
		if (filtrosRedux.embarqueInicio !== "01-01-2020") {
			setValuesSelect((current) => ({
				...current,
				embarqueInicio: filtrosRedux.embarqueInicio,
			}));
		}
		if (window.location.href.endsWith("diaria-veiculos")) {
			const date = new Date();
			var primeiroDiaDisp = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate() - 2
			)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			let data1Disp = converterData(primeiroDiaDisp);
			var primeiroDia = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate() - 8
			)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			let data1 = converterData(primeiroDia);
			var ultimoDia = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate() + 8
			)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			let data2 = converterData(ultimoDia);
			if (filtrosRedux.embarqueFinal !== "01-01-2050") {
				if (filtrosRedux.embarqueFinal === undefined) {
					setValuesSelect((current) => ({ ...current, embarqueFinal: data2 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueFinal: data2,
					}));
				} else {
					const data1 = converterData(filtrosRedux.embarqueFinal);
					setValuesSelect((current) => ({ ...current, embarqueFinal: data1 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueFinal: data1,
					}));
				}
			} else {
				setValuesSelect((current) => ({ ...current, embarqueFinal: data2 }));
				setValuesPesquisa((current) => ({ ...current, embarqueFinal: data2 }));
			}
			if (filtrosRedux.embarqueFinalDisp !== "01-01-2050") {
				if (filtrosRedux.embarqueFinalDisp === undefined) {
					setValuesSelect((current) => ({
						...current,
						embarqueFinalDisp: data2,
					}));
					setValuesPesquisa((current) => ({
						...current,
						embarqueFinalDisp: data2,
					}));
				} else {
					const data2 = converterData(filtrosRedux.embarqueFinalDisp);
					setValuesSelect((current) => ({
						...current,
						embarqueFinalDisp: data2,
					}));
					setValuesPesquisa((current) => ({
						...current,
						embarqueFinalDisp: data2,
					}));
				}
			} else {
				setValuesSelect((current) => ({
					...current,
					embarqueFinalDisp: data2,
				}));
				setValuesPesquisa((current) => ({
					...current,
					embarqueFinalDisp: data2,
				}));
			}
			if (filtrosRedux.embarqueInicio !== "01-01-2020") {
				if (filtrosRedux.embarqueInicio === undefined) {
					setValuesSelect((current) => ({ ...current, embarqueInicio: data1 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueInicio: data1,
					}));
				} else {
					const data1 = converterData(filtrosRedux.embarqueInicio);
					setValuesSelect((current) => ({ ...current, embarqueInicio: data1 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueInicio: data1,
					}));
				}
			} else {
				setValuesSelect((current) => ({ ...current, embarqueInicio: data1 }));
				setValuesPesquisa((current) => ({ ...current, embarqueInicio: data1 }));
			}
			if (filtrosRedux.embarqueInicioDisp !== "01-01-2020") {
				if (filtrosRedux.embarqueInicioDisp === undefined) {
					setValuesSelect((current) => ({
						...current,
						embarqueInicioDisp: data1Disp,
					}));
					setValuesPesquisa((current) => ({
						...current,
						embarqueInicioDisp: data1Disp,
					}));
				} else {
					const data2 = converterData(filtrosRedux.embarqueInicioDisp);
					setValuesSelect((current) => ({
						...current,
						embarqueInicioDisp: data2,
					}));
					setValuesPesquisa((current) => ({
						...current,
						embarqueInicioDisp: data2,
					}));
				}
			} else {
				setValuesSelect((current) => ({
					...current,
					embarqueInicioDisp: data1Disp,
				}));
				setValuesPesquisa((current) => ({
					...current,
					embarqueInicioDisp: data1Disp,
				}));
			}
		}
		if (
			window.location.href.endsWith("dashboard") ||
			window.location.href.endsWith("faturamento") ||
			window.location.href.endsWith("estadia") ||
			window.location.href.endsWith("ontime") ||
			window.location.href.endsWith("ontime-embarque") ||
			window.location.href.endsWith("ontime-entrega") ||
			window.location.search.includes("id=") ||
			(isRotaViagens && contextoEmbarque !== "templateEmbarque") ||
			window.location.href.endsWith("dashboard-cockpit") ||
			window.location.href.endsWith("cliente") ||
			window.location.href.endsWith("pedido") ||
			window.location.href.endsWith("motorista") ||
			window.location.href.endsWith("conjuntos") ||
			window.location.href.endsWith("responsaveis") ||
			window.location.href.endsWith("rastreamento") ||
			window.location.href.endsWith("dashboard-cotacao") ||
			window.location.href.endsWith("caminhoes") ||
			window.location.href.endsWith("carretas") ||
			window.location.href.endsWith("proprietario") ||
			window.location.href.endsWith("dashboard-ocorrencias") ||
			window.location.href.endsWith("diaria-veiculos") ||
			window.location.href.endsWith("mesorregiao") ||
			window.location.href.endsWith("mapa-meso")
		) {
			setValuesPesquisa((current) => ({ ...current, item: filtrosRedux.item }));
			setValuesPesquisa((current) => ({
				...current,
				pesquisa: filtrosRedux.pesquisa,
			}));
			if (filtrosRedux.embarqueFinal !== "01-01-2050") {
				if (filtrosRedux.embarqueFinal === undefined) {
					var date = new Date();
					var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0)
						.toLocaleDateString("pt-BR", {
							year: "numeric",
							month: "numeric",
							day: "numeric",
						})
						.replace(/\//g, "-");
					const data2 = converterData(ultimoDia);
					setValuesSelect((current) => ({ ...current, embarqueFinal: data2 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueFinal: data2,
					}));
				} else {
					const data1 = converterData(filtrosRedux.embarqueFinal);
					setValuesSelect((current) => ({ ...current, embarqueFinal: data1 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueFinal: data1,
					}));
				}
			} else {
				var date = new Date();
				var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0)
					.toLocaleDateString("pt-BR", {
						year: "numeric",
						month: "numeric",
						day: "numeric",
					})
					.replace(/\//g, "-");
				const data2 = converterData(ultimoDia);
				setValuesSelect((current) => ({ ...current, embarqueFinal: data2 }));
				setValuesPesquisa((current) => ({ ...current, embarqueFinal: data2 }));
			}
			if (filtrosRedux.embarqueInicio !== "01-01-2020") {
				if (filtrosRedux.embarqueInicio === undefined) {
					var date = new Date();
					var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
						.toLocaleDateString("pt-BR", {
							year: "numeric",
							month: "numeric",
							day: "numeric",
						})
						.replace(/\//g, "-");
					const data1 = converterData(primeiroDia);
					setValuesSelect((current) => ({ ...current, embarqueInicio: data1 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueInicio: data1,
					}));
				} else {
					const data1 = converterData(filtrosRedux.embarqueInicio);
					setValuesSelect((current) => ({ ...current, embarqueInicio: data1 }));
					setValuesPesquisa((current) => ({
						...current,
						embarqueInicio: data1,
					}));
				}
			} else {
				var date = new Date();
				var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
					.toLocaleDateString("pt-BR", {
						year: "numeric",
						month: "numeric",
						day: "numeric",
					})
					.replace(/\//g, "-");
				const data1 = converterData(primeiroDia);
				setValuesSelect((current) => ({ ...current, embarqueInicio: data1 }));
				setValuesPesquisa((current) => ({ ...current, embarqueInicio: data1 }));
			}
		}
		if (
			(window.location.href.endsWith("faturamento") ||
				window.location.href.endsWith("estadia") ||
				window.location.href.endsWith("ontime") ||
				window.location.href.endsWith("ontime-embarque") ||
				window.location.href.endsWith("ontime-entrega") ||
				window.location.search.includes("id=") ||
				window.location.search.includes("mesoregiao") ||
				window.location.href.endsWith("mapa-meso") ||
				(isRotaViagens && contextoEmbarque !== "templateEmbarque")) &&
			!filtrosRedux.embarqueInicio &&
			!filtrosRedux.embarqueFinal
		) {
			var date = new Date();
			var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0)
				.toLocaleDateString("pt-BR", {
					year: "numeric",
					month: "numeric",
					day: "numeric",
				})
				.replace(/\//g, "-");
			const data1 = converterData(primeiroDia);
			const data2 = converterData(ultimoDia);
			setValuesSelect((current) => ({
				...current,
				embarqueInicio: data1,
				embarqueFinal: data2,
			}));
			setValuesPesquisa((current) => ({
				...current,
				embarqueInicio: data1,
				embarqueFinal: data2,
			}));
		} else if (filtrosRedux.embarqueInicio && filtrosRedux.embarqueFinal) {
			const data1 = converterData(filtrosRedux.embarqueInicio);
			const data2 = converterData(filtrosRedux.embarqueFinal);
			setValuesSelect((current) => ({
				...current,
				embarqueInicio: data1,
				embarqueFinal: data2,
			}));
			setValuesPesquisa((current) => ({
				...current,
				embarqueInicio: data1,
				embarqueFinal: data2,
			}));
		}
		if (isRotaLocalizadorVeiculos || isRotaMapaMeso) {
			const data1 = formatarData(new Date());

			setValuesSelect((current) => ({
				...current,
				embarqueInicio: data1,
				embarqueFinal: data1,
			}));
			setValuesPesquisa((current) => ({
				...current,
				embarqueInicio: data1,
				embarqueFinal: data1,
			}));
		}
	}, []);

	const zerarDataRedux = useCallback(() => {
		setFiltrosRedux((current) => ({
			...current,
			embarqueInicio: primeiroDiaDosMesFormatado,
			embarqueFinal: ultimoDiaDosMesFormatado,
			item: undefined,
			pesquisa: undefined,
		}));
		setValuesSelect((current) => ({
			...current,
			embarqueInicio: primeiroDiaDosMesFormatado,
			embarqueFinal: ultimoDiaDosMesFormatado,
		}));
	}, [setFiltrosRedux]);

	useEffect(() => {
		if (prevPathname.current !== location.pathname) {
			zerarDataRedux();
			if (isRotaFaturamento) {
				setFiltrosRedux((current) => ({ ...current, menu: "faturamento" }));
			}
			if (
				isRotaDashboard ||
				isRotaDashboardSegundo ||
				isRotaDashboardTerceiro
			) {
				setFiltrosRedux((current) => ({ ...current, menu: "dashboard" }));
			}
			if (
				isRotaViagens ||
				isRotaMesorregiao ||
				isRotaMapaMeso ||
				(isRotaViagens && contextoEmbarque !== "templateEmbarque")
			) {
				setFiltrosRedux((current) => ({ ...current, menu: "embarque" }));
			}
			prevPathname.current = location.pathname;
		}
	}, [location.pathname]);

	return (
		<>
			<div className={classe}>
				<div className="wrapper-filtro">
					{isRotaViagens &&
						window.location.href.endsWith("mesorregiao") &&
						contextoEmbarque !== "templateEmbarque" &&
						window.location.search.includes("id=") && (
							<img
								className="botoes-mes"
								src={iconeAnterior}
								onClick={() => {
									mesAnterior();
								}}
							/>
						)}
					{window.location.href.endsWith("diaria-veiculos") && (
						<>
							<div
								style={{ display: "flex", flexDirection: "column", gap: "5px" }}
								className="div-datas-v2"
							>
								<p>Selecione o Tipo:</p>
								<div
									className="card-cidade-filial"
									onClick={onClickElegivelBrf}
								>
									{openElegivelBrf && (
										<div className="select-options2">
											<div className="option2">
												<b>Tipo</b>
											</div>
											{opcoesBrf.map((item) => {
												return (
													<div
														className={
															item.opcao === opcaoSelecionadaElegivelBrf
																? "option selected"
																: "option"
														}
														key={item.opcao}
														onClick={() => {
															onClickOpcaoElegivelBrf(
																item.valor,
																item.valor,
																item.opcao,
																"true"
															);
														}}
													>
														{item.opcao}
													</div>
												);
											})}
										</div>
									)}
									<b>{elegivelBrfFiltro}</b>
								</div>
							</div>
						</>
					)}
					{isRotaLocalizadorVeiculos && (
						<>
							<div
								style={{ display: "flex", flexDirection: "column", gap: "5px" }}
								className="div-datas-v2"
							>
								<p>Selecione o Tipo:</p>
								<div className="card-cidade-filial" onClick={onClickTipo}>
									{openTipo && (
										<div className="select-options2">
											<div className="option2">
												<b>Tipo</b>
											</div>
											{opcoesTipo.map((item) => {
												return (
													<div
														className={
															item.opcao === opcaoSelecionadaTipo
																? "option selected"
																: "option"
														}
														key={item.opcao}
														onClick={() => {
															onClickOpcaoTipo(
																item.valor,
																item.valor,
																item.opcao,
																"true"
															);
														}}
													>
														{item.opcao}
													</div>
												);
											})}
										</div>
									)}
									<b>{tipoFiltro}</b>
								</div>
							</div>
						</>
					)}
					{((isRotaViagens && contextoEmbarque !== "templateEmbarque") ||
						isRotaLocalizadorVeiculos ||
						window.location.href.endsWith("mapa-meso") ||
						window.location.href.endsWith("mesorregiao") ||
						window.location.href.endsWith("diaria-veiculos") ||
						window.location.href.endsWith("dashboard") ||
						window.location.href.endsWith("dashboard-terceiro") ||
						window.location.href.endsWith("dashboard-quarto") ||
						window.location.href.endsWith("dashboard-cockpit") ||
						window.location.href.endsWith("faturamento") ||
						window.location.href.endsWith("estadia") ||
						window.location.href.endsWith("responsaveis") ||
						window.location.href.endsWith("dashboard-ocorrencias") ||
						window.location.href.endsWith("ontime") ||
						window.location.href.endsWith("ontime-embarque") ||
						window.location.href.endsWith("ontime-entrega") ||
						window.location.href.endsWith("dashboard-cotacao") ||
						window.location.search.includes("id=")) && (
						<>
							<div className="div-datas-v2">
								<p className="texto-filtro" htmlFor="embarque">
									Início
								</p>
							</div>
						</>
					)}
					{((isRotaViagens && contextoEmbarque !== "templateEmbarque") ||
						isRotaLocalizadorVeiculos ||
						window.location.href.endsWith("mapa-meso") ||
						window.location.href.endsWith("mesorregiao") ||
						window.location.href.endsWith("diaria-veiculos") ||
						window.location.href.endsWith("dashboard") ||
						window.location.href.endsWith("dashboard-terceiro") ||
						window.location.href.endsWith("dashboard-quarto") ||
						window.location.href.endsWith("dashboard-cockpit") ||
						window.location.href.endsWith("faturamento") ||
						window.location.href.endsWith("estadia") ||
						window.location.href.endsWith("responsaveis") ||
						window.location.href.endsWith("dashboard-ocorrencias") ||
						window.location.href.endsWith("ontime") ||
						window.location.href.endsWith("ontime-embarque") ||
						window.location.href.endsWith("ontime-entrega") ||
						window.location.href.endsWith("dashboard-cotacao") ||
						window.location.search.includes("id=")) && (
						<div className="filtro-data-container">
							<div className="div-datas-v2-margem">
								<input
									type={"date"}
									className="input-filtro-date"
									value={valuesSelect.embarqueInicio}
									style={{ width: 120 }}
									onChange={(e) => {
										const value = e.target.value;
										const formattedDate = converterData(e.target.value);
										setValuesPesquisa((current) => ({
											...current,
											embarqueInicio: e.target.value,
										}));
										setFiltrosRedux((current) => ({
											...current,
											embarqueInicio: formattedDate,
										}));
										setValuesSelect((current) => ({
											...current,
											embarqueInicio: e.target.value,
										}));
										setInputDisable(false);
									}}
									id="embarque"
								/>
							</div>
							<div className="filtro-data-divider" style={{ height: "0px" }} />
							<div className="div-datas-v2-margem-2">
								<input
									type={"date"}
									className="input-filtro-date"
									value={valuesSelect.embarqueFinal}
									style={{ width: 120 }}
									onChange={(e) => {
										const formattedDate = converterData(e.target.value);
										setValuesPesquisa((current) => ({
											...current,
											embarqueFinal: e.target.value,
										}));
										setFiltrosRedux((current) => ({
											...current,
											embarqueFinal: formattedDate,
										}));
										setValuesSelect((current) => ({
											...current,
											embarqueFinal: e.target.value,
										}));
										setInputDisable(false);
									}}
									id="embarquef"
								/>
							</div>
						</div>
					)}
					{((isRotaViagens && contextoEmbarque !== "templateEmbarque") ||
						isRotaLocalizadorVeiculos ||
						window.location.href.endsWith("mapa-meso") ||
						window.location.href.endsWith("mesorregiao") ||
						window.location.href.endsWith("diaria-veiculos") ||
						window.location.href.endsWith("dashboard") ||
						window.location.href.endsWith("dashboard-terceiro") ||
						window.location.href.endsWith("dashboard-quarto") ||
						window.location.href.endsWith("dashboard-cockpit") ||
						window.location.href.endsWith("faturamento") ||
						window.location.href.endsWith("estadia") ||
						window.location.href.endsWith("dashboard-ocorrencias") ||
						window.location.href.endsWith("responsaveis") ||
						window.location.href.endsWith("ontime") ||
						window.location.href.endsWith("ontime-embarque") ||
						window.location.href.endsWith("ontime-entrega") ||
						window.location.href.endsWith("dashboard-cotacao") ||
						window.location.search.includes("id=")) && (
						<>
							<div className="div-datas-v2">
								<p className="texto-filtro" htmlFor="embarque">
									Fim
								</p>
							</div>
						</>
					)}
					{window.location.href.endsWith("diaria-veiculos") && (
						<>
							<div className="div-datas-v2">
								<p className="texto-filtro" htmlFor="embarque">
									Início Disp
								</p>
							</div>
						</>
					)}
					{window.location.href.endsWith("diaria-veiculos") && (
						<div className="filtro-data-container">
							<div className="div-datas-v2-margem">
								<input
									type={"date"}
									className="input-filtro-date"
									value={valuesSelect.embarqueInicioDisp}
									style={{ width: 120 }}
									onChange={(e) => {
										const formattedDate = converterData(e.target.value);
										setValuesPesquisa((current) => ({
											...current,
											embarqueInicioDisp: e.target.value,
										}));
										setFiltrosRedux((current) => ({
											...current,
											embarqueInicioDisp: formattedDate,
										}));
										setValuesSelect((current) => ({
											...current,
											embarqueInicioDisp: e.target.value,
										}));
										setInputDisable(false);
									}}
									id="embarque"
								/>
							</div>
							<div className="filtro-data-divider" />
							<div className="div-datas-v2-margem-2">
								<input
									type={"date"}
									className="input-filtro-date"
									value={valuesSelect.embarqueFinalDisp}
									style={{ width: 120 }}
									onChange={(e) => {
										const formattedDate = converterData(e.target.value);
										setValuesPesquisa((current) => ({
											...current,
											embarqueFinalDisp: e.target.value,
										}));
										setFiltrosRedux((current) => ({
											...current,
											embarqueFinalDisp: formattedDate,
										}));
										setValuesSelect((current) => ({
											...current,
											embarqueFinalDisp: e.target.value,
										}));
										setInputDisable(false);
									}}
									id="embarquef"
								/>
							</div>
						</div>
					)}
					{location.pathname === "diaria-veiculos" && (
						<>
							<div className="div-datas-v2">
								<p className="texto-filtro" htmlFor="embarque">
									Fim Disp
								</p>
							</div>
						</>
					)}
					{isRotaViagens &&
					window.location.href.endsWith("mesorregiao") &&
					contextoEmbarque !== "templateEmbarque" &&
					window.location.search.includes("id=") ? (
						<img
							className="botoes-mes"
							src={iconeProximo}
							onClick={() => {
								mesSeguinte();
							}}
						/>
					) : (
						<></>
					)}
				</div>
				<div className="wrapper-filtro">
					{location.pathname !== "dashboard-cotacao" && (
						<>
							<div className="div-datas-v2">
								{!isRotaMotorista && !isRotaViagens && (
									<div
										className="card-cidade-filial"
										style={{ minHeight: "40px" }}
										onClick={onClickFiltrar}
									>
										<Icon name="Filter" size="xl" theme="dark" />
										<Separator direction="horizontal" size="sm" />
										{openFiltrar && (
											<div className="select-options">
												<div
													className="option2"
													onClick={() => {
														setValuesPesquisa((current) => ({
															...current,
															item: "undefined",
															pesquisa: "",
														}));
														setFiltroSelecionado(undefined);
													}}
												>
													<b>Filtrar</b>
												</div>
												{itensFiltro.map((item) => (
													<div
														className={
															item.field === opcaoSelecionada
																? "option selected"
																: "option"
														}
														key={item.field}
														onClick={() => {
															onClickOpcaoFiltrar(
																item.field,
																item.field,
																item.nomeColuna
															);
														}}
													>
														{item.nomeColuna}
													</div>
												))}
											</div>
										)}
										<b>Filtrar Por: </b>
										<b>{filtroSelecionado}</b>
									</div>
								)}
								{contextoEmbarque !== "templateEmbarque" &&
									!isRotaDashboardCotacao &&
									!isRotaLocalizadorVeiculos &&
									!isRotaMapaMeso &&
									!isRotaMotorista && (
										<div className="div-datas-v2">
											<div
												className="card-filtro"
												onClick={(e) => {
													setOpenMultiplosFiltros(true);
												}}
											>
												<b>Múltiplos Filtros</b>
											</div>
										</div>
									)}
							</div>
							<div className="div-datas-v2">
								{loadingInput ? (
									<>
										<Box sx={{ width: "100%" }}>
											<LinearProgress />
										</Box>
									</>
								) : (
									<>
										<div className="div-pesquisar-filtro">
											<input
												type={"text"}
												className="input-filtro-data-v2"
												value={valuesPesquisa.pesquisa || ""}
												placeholder="Pesquisar"
												onChange={(e) => {
													setValuesPesquisa((current) => ({
														...current,
														pesquisa: e.target.value,
													}));
													setFiltrosRedux((current) => ({
														...current,
														pesquisa: e.target.value,
													}));
													setInputDisable(false);
												}}
												onKeyDown={(e) => {
													if (e.key === "Enter") {
														e.preventDefault();
														buscarSearch();
													}
												}}
												id="embarque"
											/>
											<div
												className="buscar-filtro"
												onClick={(e) => {
													buscarSearch();
												}}
											>
												<Icon name="Search" size="xl" theme="dark" />
											</div>
										</div>
									</>
								)}
							</div>
						</>
					)}

					{(window.location.href.endsWith("dashboard") ||
						window.location.href.endsWith("dashboard-terceiro") ||
						window.location.href.endsWith("dashboard-quarto") ||
						window.location.href.endsWith("faturamento") ||
						window.location.href.endsWith("estadia") ||
						window.location.href.endsWith("ontime") ||
						window.location.href.endsWith("ontime-embarque") ||
						window.location.href.endsWith("ontime-entrega") ||
						window.location.href.endsWith("responsaveis") ||
						window.location.href.endsWith("relatorio-proprietarios") ||
						isRotaLocalizadorVeiculos ||
						window.location.href.endsWith("mapa-meso") ||
						window.location.href.endsWith("diaria-veiculos")) && (
						<>
							<div className="div-datas-v2">
								<div
									className="card-cidade-filial"
									style={{ minHeight: "40px" }}
									onClick={onClickCidade}
								>
									<Icon name="MapPin" size="xl" theme="dark" />
									{openCidade && (
										<div className="select-options2">
											<div className="option2">
												<b>Filial</b>
											</div>
											{dadosFilial.map((item) => {
												if (item.nomeFilial !== "Modelo Viagens") {
													return (
														<div
															className={
																item.contexto === opcaoSelecionadaCidade
																	? "option selected"
																	: "option"
															}
															key={item.nomeFilial}
															onClick={() => {
																onClickOpcaoCidade(
																	item.contexto,
																	item.contexto,
																	item.nomeFilial,
																	"true"
																);
															}}
														>
															{item.nomeFilial}
														</div>
													);
												}
											})}
										</div>
									)}
									<b>{cidadeFiltro}</b>
								</div>
							</div>
						</>
					)}
					{window.location.href.endsWith("dashboard-cockpit") && (
						<>
							<div className="div-datas-v2">
								<div
									className="card-grupo-cliente"
									onClick={onClickGrupoCliente}
								>
									{openGrupoCliente && (
										<div className="select-options3">
											<div className="option3">
												<b>Grupo Cliente</b>
											</div>
											{listaGrupos.map((item) => {
												return (
													<div
														className={
															item.idGrupoCliente ===
															opcaoSelecionadaGrupoCliente
																? "option selected"
																: "option"
														}
														key={item.nome}
														onClick={() => {
															onClickOpcaoGrupoCliente(
																item.idGrupoCliente,
																item.idGrupoCliente,
																item.nome,
																"true"
															);
														}}
													>
														{item.nome}
													</div>
												);
											})}
										</div>
									)}
									<b>Grupo: </b>
									<b>{grupoClienteFiltro}</b>
								</div>
							</div>
						</>
					)}
					<Tooltip title={<p>Limpar Filtro</p>}>
						<motion.div
							initial={{ rotate: 0 }}
							whileHover={{ rotate: 90 }}
							transition={{ duration: 0.2, ease: "easeInOut" }}
							className="select-field-chevron"
						>
							<IconButton
								icon="X"
								size="xl"
								borderColor="none"
								onClick={() => {
									limpar();
									setFiltrosRedux((current) => ({
										...current,
										embarqueInicio: isRotaLocalizadorVeiculos
											? hojeFormatado
											: primeiroDiaDosMesFormatado,
										embarqueFinal: isRotaLocalizadorVeiculos
											? hojeFormatado
											: ultimoDiaDosMesFormatado,
										item: undefined,
										pesquisa: undefined,
									}));
									setValuesPesquisa({
										embarqueInicio: isRotaLocalizadorVeiculos
											? hojeFormatado
											: primeiroDiaDosMesFormatado,
										embarqueFinal: isRotaLocalizadorVeiculos
											? hojeFormatado
											: ultimoDiaDosMesFormatado,
										contexto: "todos",
										item: undefined,
										pesquisa: undefined,
										...(isRotaLocalizadorVeiculos && {
											tipo: 3,
										}),
									});
									setCidadeFiltro("Todos");
									setOpcaoSelecionadaCidade("Todos");
									setValuesSelect((current) => ({
										...current,
										embarqueInicio: isRotaLocalizadorVeiculos
											? hojeFormatado
											: primeiroDiaDosMesFormatado,
										embarqueFinal: isRotaLocalizadorVeiculos
											? hojeFormatado
											: ultimoDiaDosMesFormatado,
									}));
									if (isRotaLocalizadorVeiculos) {
										setTipoFiltro("Descarregando");
										setOpcaoSelecionadaTipo(3);
										setValuesSelect((current) => ({
											...current,
											embarqueFinal: formatarDataISO(new Date()),
											embarqueInicio: formatarDataISO(new Date()),
										}));
										setValuesPesquisa((current) => ({
											...current,
											embarqueInicio: formatarDataISO(new Date()),
											embarqueFinal: formatarDataISO(new Date()),
										}));
									}
									if (isRotaMapaMeso) {
										setValuesSelect((current) => ({
											...current,
											embarqueFinal: formatarDataISO(new Date()),
											embarqueInicio: formatarDataISO(new Date()),
										}));
										setValuesPesquisa((current) => ({
											...current,
											embarqueInicio: formatarDataISO(new Date()),
											embarqueFinal: formatarDataISO(new Date()),
										}));
									}
								}}
								backgroundColor="rgba(0, 0, 0, 0)"
								theme="dark"
							/>
						</motion.div>
					</Tooltip>
					{isRotaViagens &&
						window.location.search.includes("id=") &&
						contextoEmbarque !== "templateEmbarque" && (
							<>
								<div className="div-datas-v2">
									<div className="card-filtro" onClick={onClickOpcionais}>
										{openOpcionais && (
											<div className="select-options4">
												<div className="option4">
													<input
														type="checkbox"
														className="check-periodo"
														checked={periodoCompleto}
														onChange={(e) => {
															setCompleto(e.target.checked);
															setPeriodoCompleto(e.target.checked);
														}}
													/>
													<p className="texto-periodo">Período Completo</p>
												</div>
												<div className="option4">
													<input
														type="checkbox"
														className="check-periodo"
														checked={estadia}
														onChange={(e) => {
															setEstadia(e.target.checked);
															setFiltroEstadia(e.target.checked);
														}}
													></input>
													<p className="texto-periodo">Estadia</p>
												</div>
											</div>
										)}
										<b>Opcionais</b>
									</div>
								</div>
							</>
						)}
					{multiplosFiltrosRedux && multiplosFiltrosRedux.length && (
						<div
							className="div-datas-v2"
							style={{
								display: "flex",
								flexWrap: "wrap",
								gap: 10,
							}}
						>
							{multiplosFiltrosRedux.map((filtro) => {
								return (
									<div className="card-filtro-multiple">
										<b>
											{filtro.coluna}: {filtro.valor}
										</b>
									</div>
								);
							})}
						</div>
					)}
				</div>
			</div>
			<div>
				<ModalMultiplosFiltros
					titulo="Filtrar"
					tituloConfirmar="OK"
					open={openMultiplosFiltros}
					onClick={buscarSearch}
					onClose={handleCloseMultiplosFiltros}
					classOption={classOption}
					itensFiltro={itensFiltro}
					onClickFiltrar={onClickFiltrar2}
					openFiltrar={openFiltrar2}
					opcaoSelecionada={opcaoSelecionada}
					onClickOpcaoFiltrar={onClickOpcaoFiltrar}
					filtroSelecionado={filtroSelecionado}
					loadingInput={loadingInput}
					setValuesPesquisa={setValuesPesquisa}
					setFiltrosRedux={setFiltrosRedux}
					setInputDisable={setInputDisable}
					buscarSearch={buscarSearch}
					valuesPesquisa={valuesPesquisa}
				/>
			</div>
		</>
	);
}

export default FiltroV2;
